import { render, staticRenderFns } from "./EditMicrofilmDialog.vue?vue&type=template&id=10c8be41"
import script from "./EditMicrofilmDialog.vue?vue&type=script&lang=js"
export * from "./EditMicrofilmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports